<div *ngIf="eventData">

    <div class="flex gap-3">
        <div>
            <!-- <span class="text-xs bg-blue-100 text-blue-500 font-medium px-2 py-0.5 rounded-full">Lecture</span> -->

            <label class="label p-0 uppercase text-zinc-500">{{eventData.type == 'course' ? 'course' : 'event'}}</label>
            <h1 class="text-xl font-medium">{{eventData.title}}</h1>
            <div *ngIf="eventData.course_name" class="text-sm text-zinc-500 mt-1">Course: {{eventData.course_name}}</div>
            <span class="text-xs text-zinc-500 font-medium">{{eventData.eventDate[0] | date:'long'}} |
                {{eventData.eventTime[0]}} - {{eventData.eventTime[1]}} </span>
            <div class="flex gap-2 mt-2">
                <!-- <span>Weekly : Monday, Tuesday, Friday</span> -->
            </div>
        </div>
    </div>

    <div class="flex flex-col gap-5 mt-5">

        <!-- Date and Time Information -->
        <div class="flex gap-5">
            <i class="ri-calendar-event-line font-semibold"></i>
            <div>
                <label class="label p-0 uppercase text-zinc-500">Schedule Details</label>
                <div class="text-sm">
                    <div><strong>Start:</strong> {{eventData.eventDate[0]}} {{eventData.eventTime[0]}}</div>
                    <div><strong>End:</strong> {{eventData.eventDate[0]}} {{eventData.eventTime[1]}}</div>
                </div>
            </div>
        </div>

        <div class="flex gap-5 items-center" *ngIf="eventData.link">
            <i class="ri-link font-semibold"></i>
            <div class="flex justify-between items-center w-full bg-zinc-100 p-2 rounded-lg">
                <p class="">{{eventData.link}}</p>
                <button class="btn btn-xs btn-square"><i class="ri-file-copy-line"></i></button>
            </div>
        </div>

        <div class="flex gap-5">
            <i class="ri-quote-text font-semibold"></i>
            <div>
                <p class="text-sm">{{eventData.description}}</p>

                <label class="label mt-3 uppercase text-zinc-500 underline" *ngIf="eventData.parameters && eventData.parameters.length > 0">Parameters</label>
                <div class="flex gap-2 flex-wrap" *ngIf="eventData.parameters && eventData.parameters.length > 0">
                    @for (i of eventData.parameters; track $index) {
                    <span class="bg-zinc-100 text-zinc-500 text-xs font-semibold px-3 py-1 rounded-full">{{i}}</span>
                    }
                </div>

            </div>
        </div>

        <!-- Attendees -->
        <div class="flex gap-5" *ngIf="eventData.attendee_details && eventData.attendee_details.length > 0">
            <i class="ri-group-line font-semibold mt-1"></i>
            <div>
                <label class="label p-0 uppercase text-zinc-500">Teacher</label>
                <div class="flex gap-2 flex-wrap">
                    @for (attendee of eventData.attendee_details; track $index) {
                    <span class="flex gap-1 items-center bg-orange-100 text-orange-600 rounded-md py-1 px-3">
                        <i class="ri-user-3-line font-semibold"></i>
                        {{attendee}}
                    </span>
                    }
                </div>
            </div>
        </div>

        <!-- Classes -->
        <div class="flex gap-5" *ngIf="eventData.class_details && eventData.class_details.length > 0">
            <i class="ri-graduation-cap-line font-semibold mt-1"></i>
            <div>
                <label class="label p-0 uppercase text-zinc-500">Classes</label>
                <div class="flex gap-2 flex-wrap">
                    @for (cls of eventData.class_details; track $index) {
                    <span class="flex gap-1 items-center bg-blue-100 text-blue-600 rounded-md py-1 px-3">
                        <i class="ri-book-line font-semibold"></i>
                        {{cls.class_name}}
                    </span>
                    }
                </div>
            </div>
        </div>

        <!-- Batches -->
        <div class="flex gap-5" *ngIf="eventData.batch_details && eventData.batch_details.length > 0">
            <i class="ri-group-2-line font-semibold mt-1"></i>
            <div>
                <label class="label p-0 uppercase text-zinc-500">Batches</label>
                <div class="flex gap-2 flex-wrap">
                    @for (batch of eventData.batch_details; track $index) {
                    <span class="flex gap-1 items-center bg-green-100 text-green-600 rounded-md py-1 px-3">
                        <i class="ri-team-line font-semibold"></i>
                        {{batch.batch_name}} 
                    </span>
                    }
                </div>
            </div>
        </div>

        <!-- Departments -->
        <div class="flex gap-5" *ngIf="eventData.department_details && eventData.department_details.length > 0">
            <i class="ri-building-line font-semibold mt-1"></i>
            <div>
                <label class="label p-0 uppercase text-zinc-500">Departments</label>
                <div class="flex gap-2 flex-wrap">
                    @for (dept of eventData.department_details; track $index) {
                    <span class="flex gap-1 items-center bg-purple-100 text-purple-600 rounded-md py-1 px-3">
                        <i class="ri-building-2-line font-semibold"></i>
                        {{dept.department_name}} 
                    </span>
                    }
                </div>
            </div>
        </div>

        <!-- Groups -->
        <div class="flex gap-5" *ngIf="eventData.group_details && eventData.group_details.length > 0">
            <i class="ri-group-line font-semibold mt-1"></i>
            <div>
                <label class="label p-0 uppercase text-zinc-500">Groups</label>
                <div class="flex gap-2 flex-wrap">
                    @for (group of eventData.group_details; track $index) {
                    <span class="flex gap-1 items-center bg-yellow-100 text-yellow-600 rounded-md py-1 px-3">
                        <i class="ri-group-3-line font-semibold"></i>
                        {{group.name || group.group_name}} 
                    </span>
                    }
                </div>
            </div>
        </div>

        <div class="flex gap-5" *ngIf="eventData.location">
            <i class="ri-map-pin-2-line font-semibold"></i>
            <p>{{eventData.location}}</p>
        </div>

    </div>

</div>

<div *ngIf="!eventData" class="flex justify-center items-center p-8">
  <p class="text-zinc-500">Event data not found</p>
</div>